import { TEnvConfig } from './env.interfact'
import { ChainId } from '@/lib/chain'

export const PROD_CONFIG: TEnvConfig = {
  amplitudeApiKey: '5ad5eaf62750651e677503e7f768a944',
  supportedChains: [ChainId.ETHEREUM, ChainId.OPTIMISM, ChainId.BSC],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json'
  },
  kulapSwapFrontendUrl: 'https://swap.kulap.io',
  kulapPlusFrontendUrl: 'https://app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '370828216898781',
  initFromFiatCurrencyAmount: '100',
  checkUserEligibilityTrade: true,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0x4128c861D87781D7EC7AE9Ad87e79cE4a54c1c13',
    [ChainId.BSC]: '0x4128c861D87781D7EC7AE9Ad87e79cE4a54c1c13',
    [ChainId.OPTIMISM]: '0x4128c861D87781D7EC7AE9Ad87e79cE4a54c1c13'
  },
  thaiD: {
    apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
    clientId: 'WTBQbEZtcXY4bmlxcnU3c0ZWeGpIcmVQN3JVV21MSkk',
    redirectUri: 'https://plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
